<template>
    <default-layout>

        <BreadcrumLayout>
            <div class="flex">
                <a href="#" class="link-color"><U>Planning</U></a>
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mt-1" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd"
                        d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                        clip-rule="evenodd" />
                </svg>
                <a href="#" class="link-color"><U>Food Orders</U></a>
            </div>
        </BreadcrumLayout>
        <PageTitleLayout>
            <div class="w-full flex flex-wrap justify-between items-center">
                <h1 class="heading-color xl:text-4xl text-2xl font-bold text-left">Step 3: Review Food Order</h1>

                <div class="right-button flex">
                    <inertia-link :href="route('foodorder-detail-edit-step3') + `?order_id=${this.order_id}`" class="">
                        <button
                            class="back_button cancel-button-color text-white font-bold py-3 xl:px-8 sm:px-8 px-4 lg:ml-6 sm:ml-6 ml-0 rounded lg:mt-0 sm:mt-0 xl:mt-10">
                            BACK
                        </button>
                    </inertia-link> 


                    <button @click="saveOrder('Draft')"
                        class="cancel_button cancel-button-color text-white font-bold py-3 xl:px-8 sm:px-8 px-4 lg:ml-6 sm:ml-6 ml-6 rounded lg:mt-0 sm:mt-0 xl:mt-10">
                        SAVE AS DRAFT
                    </button>
                    <button @click="saveOrder('Complete')"
                        class="mark_as_complete button-color text-white font-bold py-3 xl:px-8 sm:px-8 px-4 lg:ml-6 sm:ml-6 ml-6 rounded lg:mt-0 sm:mt-0 xl:mt-10">
                        MARK AS COMPLETE
                    </button>

                    <a href="javascript:void(0)" @click="loadIsPrint()" class="xl:mt-12 ml-4"><svg xmlns="http://www.w3.org/2000/svg" class="xl:h-5 w-5 lg:h-5 md:h-10  mr-3 arrow-color md:mt-0 mt-4" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M5 4v3H4a2 2 0 00-2 2v3a2 2 0 002 2h1v2a2 2 0 002 2h6a2 2 0 002-2v-2h1a2 2 0 002-2V9a2 2 0 00-2-2h-1V4a2 2 0 00-2-2H7a2 2 0 00-2 2zm8 0H7v3h6V4zm0 8H7v4h6v-4z" clip-rule="evenodd"></path></svg></a>
                </div>
            </div>

        </PageTitleLayout> 

        <PageTitleLayout>

        </PageTitleLayout>

        <div class="lg:mb-0 mb-4 w-full mt-6 flex xl:px-10 px-5">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 svg_icon" viewBox="0 0 20 20" fill="#0093d0">
                <path fill-rule="evenodd"
                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                    clip-rule="evenodd" />
            </svg><span class="span-text font-bold pl-1">Confirm order details. If everything looks good, download the order
                forms from each distributor and mark as complete.</span>
        </div>

        <div id="print_food_order">

        <h3  class="heading-color xl:text-4xl text-2xl font-bold text-left ml-10 mb-3 show-only-print"> Review Food Order</h3>

        <header
            class="searching-background-color flex justify-between items-center py-2 pl-5 shadow overflow-hidden rounded-t-lg sm:mx-10 mx-6 mt-2">
            <h2 class="text-white text-lg font-bold w-11/12">Distributors</h2>
        </header>

        <div class="flex flex-col mb-6 mx-10 my_table">
            <div class="overflow-x-auto">
                <div class="align-middle inline-block min-w-full">
                    <div class="shadow overflow-hidden border-b-2 border-gray-200 sm:rounded-lg">
                        <table class="min-w-full">
                            <thead class="header-bg-color">
                                <tr>
                                    <th scope="col"
                                        class="id_arrow w-2/4 px-5 py-3 text-left xl:text-base text-sm font-bold text-black-800 uppercase tracking-wider relative">
                                        Distributor
                                    </th>
                                    <th scope="col"
                                        class="w-1/5 px-5 py-3 text-left xl:text-base text-sm font-bold text-black-800 uppercase tracking-wider">
                                        Item Count 
                                    </th>

                                    <th scope="col"
                                        class="w-1/5 px-5 py-3 text-left xl:text-base text-sm font-bold text-black-800 uppercase tracking-wider">
                                        Date Range
                                    </th>

                                    <th scope="col"
                                        class="w-1/5 px-5 py-3 text-left xl:text-base text-sm font-bold text-black-800 uppercase tracking-wider">
                                        Estimated Cost
                                    </th>
                                    <th scope="col"
                                        class="w-1/5 px-5 py-3 text-left xl:text-base text-sm font-bold text-black-800 uppercase tracking-wider no-print">
                                        DOWNLOAD
                                    </th>

                                </tr>
                            </thead>
                            <tbody>
                                <!-- Oddd row -->
                                <tr v-for="(distribute, index) in distributes" :key="index" class="bg-white">
                                    <td class="px-5 py-4 whitespace-nowrap text-base font-bold underline id-color">
                                        {{ distribute.name }}
                                    </td>
                                    <td class="px-5 py-4 whitespace-nowrap text-base text-color td-background-color">
                                        {{ Object.keys(distribute.item_array).length }}
                                    </td>

                                    <td class="px-5 py-4 whitespace-nowrap text-base text-color td-background-color">
                                        {{ getDateRange( days_covered_by_order) }}
                                    </td>

                                    <td class="px-5 py-4 whitespace-nowrap text-base text-color">
                                        {{ formatAsCurrency(distribute.estimate_cost) }}
                                    </td>

                                    <td class="px-5 py-4 whitespace-nowrap text-base font-medium text-color id-color no-print">
                                        <i @click="downloadExcel(distribute.distributor_id, 'distributor')"
                                            class="fa fa-download pr-3 cursor-pointer" aria-hidden="true"></i>
                                    </td>
                                </tr>

                                <tr v-if="unassinged > 0" class="bg-white">
                                    <td class="px-5 py-4 whitespace-nowrap text-base font-bold underline id-color">
                                        Unassigned
                                    </td>
                                    <td class="px-5 py-4 whitespace-nowrap text-base text-color td-background-color">
                                        {{ unassinged }}
                                    </td>
                                    <td class="px-5 py-4 whitespace-nowrap text-base text-color td-background-color">
                                        {{ getDateRange( days_covered_by_order) }}
                                    </td>
                                    <td class="px-5 py-4 whitespace-nowrap text-base text-color">
                                        $0.00
                                    </td>

                                    <td class="px-5 py-4 whitespace-nowrap text-base font-medium text-color id-color no-print">
                                        <i @click="downloadExcel('unassinged', 'unassinged')"
                                            class="fa fa-download pr-3 cursor-pointer" aria-hidden="true"></i>
                                    </td>


                                </tr>

                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        
            <header
                class="searching-background-color flex justify-between items-center py-2 pl-5 shadow overflow-hidden rounded-t-lg sm:mx-10 mx-6 mt-2">
                <h2 class="text-white text-lg font-bold w-11/12">Sites</h2>
            </header>

            <div class="flex flex-col mb-6 mx-10 my_table">
                <div class="overflow-x-auto">
                    <div class="align-middle inline-block min-w-full">
                        <div class="shadow overflow-hidden border-b-2 border-gray-200 sm:rounded-lg">
                            <table class="min-w-full">
                                <thead class="header-bg-color">
                                    <tr>
                                        <th scope="col"
                                            class="w-2/4 id_arrow px-5 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider relative">
                                            Offering
                                        </th>
                                        <th scope="col"
                                            class="w-1/5 px-5 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">
                                            Item Count 
                                        </th>

                                        <th scope="col"
                                            class="w-1/5 px-5 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">
                                            Date Range
                                        </th>

                                        
                                        <th scope="col"
                                            class="w-1/5 px-5 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">
                                            Estimated Cost
                                        </th>
                                        <th scope="col"
                                            class="w-1/5 px-5 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider no-print">
                                            DOWNLOAD
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <!-- Oddd row -->
                                    <tr v-for="(site, index) in allSites" :key="index" class="bg-white" v-show="site.name != 'Unknown Offering'">
                                        <td class="px-5 py-4 whitespace-nowrap text-base font-bold underline id-color" :class="{ 'pl-10': site.type === 'offering' }">
                                            {{ site.name }}
                                        </td>
                                        <td class="px-5 py-4 whitespace-nowrap text-base text-color td-background-color ">
                                             {{ Object.keys(site.quantity_order_array).length }}
                                        </td>

                                        <td class="px-5 py-4 whitespace-nowrap text-base text-color td-background-color">
                                        {{ getDateRange( days_covered_by_order) }}
                                        </td>

                                        <td class="px-5 py-4 whitespace-nowrap text-base text-color">
                                            {{ formatAsCurrency(site.estimated_cost) }}
                                        </td>

                                        <td class="px-5 py-4 whitespace-nowrap text-base font-medium text-color id-color no-print">
                                            <i @click="downloadExcel(site.id, site.type)"
                                                class="fa fa-download pr-3 cursor-pointer" aria-hidden="true"></i>
                                        </td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div> 
        
       

        <!-- <header
            class="searching-background-color flex justify-between items-center py-2 pl-5 shadow overflow-hidden rounded-t-lg sm:mx-10 mx-6 mt-2">
            <h2 class="text-white text-lg font-bold w-11/12">Days Covered by Order</h2>
        </header>
        <div class="flex flex-col mb-6 mx-10 my_table">
            <div class="overflow-x-auto">
                <div class="align-middle inline-block min-w-full">
                    <div class="shadow overflow-hidden border-b-2 border-gray-200 sm:rounded-lg">
                        <table class="min-w-full">
                            <thead class="header-bg-color">
                                <tr>
                                    <th scope="col"
                                        class="id_arrow px-5 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider relative">
                                        DATE
                                    </th>

                                </tr>
                            </thead>
                            <tbody> 
                                <tr v-for="date in days_covered_by_order" class="bg-white" v-show="formatDate(date)">
                                    <td class="px-5 py-4 whitespace-nowrap text-base font-bold date-color">
                                        {{ formatDate(date) }}
                                    </td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div> -->

        </div>
        <div class="bottom_button w-full sm:flex lg:flex-nowrap flex-nowrap lg:justify-end items-center  mb-6  px-10 mt-6">
            <div>
                <inertia-link :href="route('foodorder-detail-edit-step3') + `?order_id=${this.order_id}`" class="">
                    <button
                        class="back_button cancel-button-color text-white font-bold py-1.5 xl:px-8 sm:px-8 px-4 lg:ml-6 ml-0 rounded lg:mt-0 sm:mt-0 xl:mt-10">
                        BACK
                    </button>
                </inertia-link>
            </div>


            <button @click="saveOrder('Draft')"
                class="cancel_button cancel-button-color text-white font-bold py-1.5 xl:px-8 sm:px-8 px-4 lg:ml-6 sm:ml-6 ml-6 rounded lg:mt-0 sm:mt-0 xl:mt-10">
                SAVE AS DRAFT
            </button>
            <button @click="saveOrder('Complete')"
                class="mark_as_complete button-color text-white font-bold py-1.5 xl:px-8 sm:px-8 px-4 lg:ml-6 sm:ml-6 ml-6 rounded lg:mt-0 sm:mt-0 xl:mt-10">
                MARK AS COMPLETE
            </button>

        </div>

    </default-layout>
</template>

<script>
import DefaultLayout from "@/Layouts/DefaultLayout";
import Welcome from "@/Jetstream/Welcome";
import BreadcrumLayout from "@/Pages/Common/Breadcrumbs";
import PageTitleLayout from "@/Pages/Common/PageTitle";
import TableFilterLayout from "@/Pages/Common/TableFilters";
import TableIndexLayout from "@/Pages/Common/TableIndex";

export default {
    props: ['days_covered_by_order', 'sites', 'distributes', 'order_id', 'food_create_id', 'food_create_type', 'unassinged', 'food_order_name', 'allSites'],
    components: {
        DefaultLayout,
        Welcome,
        BreadcrumLayout,
        PageTitleLayout,
        TableFilterLayout,
        TableIndexLayout,
    },
    methods: {

         loadIsPrint() {
   // this.$refs.CalendarPrint.getCalenderDays();
   setTimeout(function () {
    var w = window.open("", "");
    w.document.write('<html><head><style type="text/css" media="print"></style>');
        w.document.write(`
<link href="https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css" rel="stylesheet">`);
    w.document.write(`<style>@media print { .no-print { display: none; } } 
        .searching-background-color {background-color: #38558e;}
        * {-webkit-print-color-adjust: exact !important; color-adjust: exact !important; }.header,.left_part,.month_year{display:flex}body{font-family:Lato,sans-serif!important;padding:20px}.header{align-items:center;justify-content:space-between;padding:30px 0;width:100%}.month_year{background:rgba(30,67,127);border-radius:15px 15px 0 0;padding:16px 12px 10px;align-items:flex-end;justify-content:space-between;width:100%;box-sizing:border-box}.month_name{color:#fff;font-size:24px;font-weight:700}table.table{width:100%;border:none;line-height:1.2}table.table thead{background:#132d56}table.table thead th{color:#fff;vertical-align:bottom;padding:5px;border-right:2px solid #233b61;font-size:12px}table.table thead th:last-child{border-right:none}table.table tr.grey_bar td{background:#e8e8e8;border-right:2px solid #d9d9d9;border-bottom-color:#d9d9d9;padding:7px 5px 6px 10px;font-size:14px;color:#454545;font-weight:600;text-align:left}table.table tr td{font-size:11px;color:#454545;text-align:center;padding:20px 5px 10px;border-style:solid;border-color:#eee #eee #cecece;border-width:2px 2px 2px 0;line-height:1.1}table.table tr td:first-child{border-left:2px solid #eee}table.table tr td p{margin:0}table.table tr td p+p{margin-top:5px}@page{size:auto;margin:0}</style>`);
    w.document.write('</head><body >');
    
    w.document.write(document.getElementById('print_food_order').innerHTML);
    w.document.write('</body></html>');
    w.document.close();
    w.focus();
    w.print();
    setTimeout(function () {
     w.close();
    }, 3000);
   }, 300);
  },

        formatAsCurrency(value) {
            // Format the number as currency with dollar symbol
            return value.toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
            });
        },

        formatDate(dateString) {
            if(dateString === null || dateString === undefined || dateString === '') {
                return null;
            }
            const dateObject = new Date(dateString);

            if (isNaN(dateObject.getTime())) {
                return null;
            }

            console.log('Date Object:', dateObject, dateString);

            const options = {
                weekday: "long",
                month: "long",
                day: "numeric",
                year: "numeric",
            };

            return dateObject.toLocaleDateString(undefined, options);
        },

        getDateRange(dates) {

        if (!dates || dates.length === 0) return "";

        // dates = Object.values(dates);
        // console.log('Dates:', dates);

        // // Sort dates
        // const sorted = [...dates].sort();

        const sorted = Object.values(dates)
        .filter(d => d)
        .sort((a, b) => new Date(a) - new Date(b));

        
       

        const minDate = sorted[0];
        const maxDate = sorted[sorted.length - 1];

         

        // Format function
        const format = (d) => {
            const date = new Date(d);

            if (isNaN(date.getTime())) {
                return ""; // or return "Invalid date"
            }

            return date.toLocaleDateString("en-US", {
                month: "short",
                day: "numeric",
                year: "numeric",
            });
            };

        

        // If only one date
        if (minDate === maxDate) {
            return format(minDate);
        }

        // Return range
        return `${format(minDate)} - ${format(maxDate)}`;
        },   
        saveOrder(type) {
            axios
                .post("/food-order/store/create4", {
                    order_id: this.order_id,
                    type: type,
                })
                .then((response) => {
                    // console.log('food-order.draft.step-4', response);
                    if (response.data.status == 'success') {
                        window.location.href = `/food-orders`;
                    }
                    // console.log(response.data.status);
                })
                .catch((error) => console.error(error));
        },
        downloadExcel(id, type) {
            console.log('Id', id);
            axios
                .get("/food-order/download/excel", {
                    params: {
                        id: id,
                        type: type,
                        order_id: this.order_id
                    },
                    responseType: 'blob'
                })
                .then((response) => {
                    // Create a blob from the response data
                    const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

                    // Generate a temporary download link
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    var fileName = '';
                    if (type == 'offering') {
                        fileName = 'offering_wise_report.xlsx';
                    } else if (type == 'distributor') {
                        fileName = 'distributor_wise_report.xlsx';

                    } else if (type == 'unassinged') {
                        fileName = 'unassinged.xlsx';
                    } else {
                        fileName = 'report.xlsx';
                    }
                    link.setAttribute('download', fileName); // Set the desired filename
                    document.body.appendChild(link);

                    // Click the link to trigger the download
                    link.click();

                    // Clean up the temporary link
                    window.URL.revokeObjectURL(url);


                })
                .catch((error) => console.error(error));
        }
    },
};
</script>

<style>
.show-only-print {
    display: none;
}
.title::after,
.title::before {
    content: '';
    position: absolute;
    right: 1.25em;
    top: 1.25em;
    width: 2px;
    height: 0.75em;
    background-color: #7A7572;
    transition: all 0.2s;
}

.date-color {
    color: #8a8a8a;
}

.content p {
    padding: 20px;
}

.min-height-third {
    min-height: 400px;
}

.span-text {
    font-size: 14px;
    color: #727272;
    padding-bottom: 5px;
}

.progress-bar>div {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    height: 23px;
    line-height: 23px;
}

.progress-text {
    font-size: 19px;
    color: #3f3f3f;
}

.progress-bar {
    background-color: #fff;
    border: 1px solid #cacaca;
    border-radius: 5px;
    height: 25px;
}

.bg-green-500 {
    background-color: #22af4b;
}

.sm\:text-sm {
    font-size: 0.850rem;
    line-height: 1.25rem;
}

.order-detail {
    color: #4a4a4a;
    font-size: 14px;
}

.w-52-rec {
    width: 13.2rem;
}

.cancel-button-color {
    background-color: #8b8b8b;
}

.input-background {
    background-color: #f8f8f8;
}

.text-base-heading {
    font-size: 14px;
}

.button-bg-color-wed-menu2-gray {
    border: none !important;
    min-height: 35px;
    min-width: 35px;
}

.menu1-background-color {
    background-color: #FAA43D;
}

.button-bg-color-wed-menu2 {
    background-color: #38558e;
    border: none !important;
    min-height: 35px;
    min-width: 35px;
}

.menu1-icon-color {
    color: #38558e;
}

.id-color-menu-edit {
    color: #F7A53A;
}

.bg-button-color {
    background-color: #cb0000;
}

.min-w-min-button {
    min-height: 26px;
    min-width: 53px;

}

.w-150 {
    width: 150px;
}

.max-w-0-menu1 {
    max-width: 4rem;
}

.bg-button-color-green {
    background-color: #22af4b;
}

.bg-button-color-gray {
    background-color: #636363;
}

.bg-hard-grey {
    background-color: #f4f4f4;
}

.font-size-edit {
    font-size: 10.5px;
}

.w-96-edit-recipes {
    width: 35rem;
}

.select-menu-height-edit2 {
    height: 2.8rem;
}

@media screen and (max-width: 1279px) {
    .searching-background-color {
        margin-left: 1.25rem;
        margin-right: 1.25rem;
    }

    .my_table {
        margin-left: 1.25rem;
        margin-right: 1.25rem;
    }

    .bottom_button {
        padding-right: 1.25rem;
        padding-left: 1.25rem;
    }
}

@media screen and (min-width: 1500px) {
    .id_arrow .fa-sort-desc:before {
        content: "\f0dd";
        position: absolute;
        top: 16px;
        left: 43px;
        padding-left: 7px;
        color: #219FD5;
    }

    .id_arrow .fa-sort-asc:before {
        content: "\f0de";
        color: #219FD5;
        padding-left: 7px;
        position: absolute;
        top: 16px;
        left: 43px;
    }
}

@media screen and (max-width: 1499px) {
    .id_arrow .fa-sort-asc:before {
        content: "\f0de";
        color: #219FD5;
        padding-left: 7px;
        position: absolute;
        top: 28px;
        left: 43px;
    }

    .id_arrow .fa-sort-desc:before {
        content: "\f0dd";
        position: absolute;
        top: 28px;
        left: 43px;
        padding-left: 7px;
        color: #219FD5;
    }

}

@media screen and (max-width: 670px) {

    .right-button,
    .order-detail {
        margin-top: 0.625rem;
    }
}

@media screen and (max-width: 479px) {

    .back_button,
    .cancel_button,
    .mark_as_complete {
        width: 70%;
        margin-top: 0.625rem;
        margin-left: 0px;
    }

    .back_button {
        margin-top: 0px;
    }

    .svg_icon {
        height: 20px;
        width: 50px;
    }
}</style>
